<script>
  import { createEventDispatcher } from 'svelte';

  import Modal from '@components/Modal.svelte';
  import Checkbox from '@components/Checkbox.svelte';
  import Text from '@components/Text.svelte';
  import Notification from '@utils/notification';
  import ComponentEvents from '@utils/component-events';
  import { getGroupStore } from '@stores/group';
  let groupStore = getGroupStore('groupStore');
  let recObjectsStore = getGroupStore('recObjectsStore');
  let recsStore = getGroupStore('recsStore');
  import RecObjectAjax from '@ajax/rec_object';

  const dispatch = createEventDispatcher();

  export let showModal = false;
  export let recObjectId;
  export let recIds;
  export let mobile = false;
  export let customGroupStore;

  let group = customGroupStore || groupStore;
  let recObject = recObjectsStore.find(recObjectId);
  let recs = recsStore.filter((r) => recIds.indexOf(r.id) != -1);

  let removableRecs = recs.filter((r) => {
    return r.permissions.delete;
  });

  let selectedRemovalRecs = {};

  let deleting = false;
  let mode = null;

  let close = function () {
    showModal = false;
    deleting = false;
    selectedRemovalRecs = {};
    dispatch('close');
  };

  let toggleRemovalRec = function (rec) {
    return function () {
      if (!selectedRemovalRecs[rec.id]) {
        selectedRemovalRecs[rec.id] = rec;
      } else {
        delete selectedRemovalRecs[rec.id];
      }
      selectedRemovalRecs = selectedRemovalRecs;
    };
  };

  let deleteRecObject = async function () {
    var recIds = Object.keys(selectedRemovalRecs);

    if (mode == 'multiple') {
      if (recIds.length == 0) {
        Notification.send({
          text: 'At least, one recommendation must be selected',
          type: 'error',
        });

        return;
      }
    } else {
      if (removableRecs && removableRecs[0]) {
        recIds = [removableRecs[0].id];
      }
    }

    deleting = true;

    try {
      RecObjectAjax.destroy(group, recObject, {
        rec_ids: recIds,
      });

      recObjectsStore.remove(recObjectsStore.find(recObject.id));

      recIds.forEach((id) => {
        recsStore.remove(recsStore.find(id));
      });

      ComponentEvents.trigger('refresh-broken-owl');

      dispatch('removed');
      close();
    } catch {}

    deleting = false;
  };

  if (removableRecs.length <= 1) {
    mode = 'single';
  } else {
    mode = 'multiple';
  }
</script>

<style style="text/scss" lang="scss">
  .ui-header {
    font-weight: 500;
    font-size: 16px;
  }

  .ui-section-name {
    margin-top: 60px;
    font-size: 25px;
    line-height: 26px;
    font-weight: 500;
  }

  .ui-items {
    margin-top: 25px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      flex-shrink: 0;
      width: 15px;
      height: 15px;
    }

    .ui-items-label {
      padding-left: 10px;
      padding-right: 10px;
      font-weight: 500;
      font-size: 13px;
    }

    .ui-items-count {
      opacity: 0.5;
      font-size: 13px;
    }
  }

  .multiple-recs {
    margin-left: 78px;
    margin-right: 78px;
    margin-top: 40px;
    display: flex;
    flex-direction: column;
  }

  .ui-actions {
    margin-top: 65px;
    max-width: 275px;
    margin-left: auto;
    margin-right: auto;

    .delete-btn {
      height: 48px;
      color: #ff5567;
      font-weight: 500;
      font-size: 14px;
      border: none;
      border-radius: 15px;
      background: #fde7e7;
      width: 275px;

      &:hover {
        color: #fff;
        background: #ff5567;
      }
    }

    .cancel-btn {
      color: #000;
      font-size: 15px;
      margin-top: 12px;
      font-weight: 500;
      border: none;
      background: transparent;
    }
  }

  .mobile {
    .multiple-recs {
      margin-left: 20px !important;
      margin-right: 20px !important;
    }
  }
</style>

{#if showModal}
  <div class="svelte-modal">
    <Modal
      mobile={mobile}
      on:close={close}
      show={showModal}
      showCloseButton={false}
      fadeInDuration={200}
      style="border-radius: 16px; width: 490px">
      <div slot="content" style="text-align: center;" class:mobile={mobile}>
        <div class="ui-header">Are you sure you want to delete this?</div>
        <div class="ui-section-name">{recObject.display_name}</div>

        {#if mode == 'multiple'}
          <div class="multiple-recs">
            {#each removableRecs as rec}
              <div style="display: flex; margin-top: 10px; margin-bottom: 10px;">
                <div style="flex-shrink: 0">
                  <Checkbox checked={selectedRemovalRecs[rec.id]} on:change={toggleRemovalRec(rec)} />
                </div>

                <div
                  style="display: flex; flex-direction: column; margin-left: 13px;
              word-break: break-word;">
                  <div style="cursor: pointer; text-align: left" on:click={toggleRemovalRec(rec)}>
                    <span>{rec.user.name}:</span>
                    <Text
                      lines={2}
                      expand={false}
                      text={rec.user_note}
                      style="display: -webkit-box !important; opacity: 0.75 !important;" />
                  </div>
                </div>
              </div>
            {/each}
          </div>
        {/if}

        <div class="ui-actions">
          <button class="delete-btn" on:click|preventDefault={deleteRecObject}>
            {#if deleting}
              <div>
                <i class="fa fa-spin fa-spinner" />
                <span style="margin-left: 10px;">Deleting</span>
              </div>
            {:else}Delete{/if}
          </button>
          <button class="cancel-btn" on:click|preventDefault={close}>Cancel</button>
        </div>
      </div>
    </Modal>
  </div>
{/if}
